<form id="passwordResetForm" (ngSubmit)="setPassword()" [formGroup]="passwordFormGroup">
    <div class="list-wrapper">
        <div class="security-measures">
            <div [ngClass]="{
                'security-measure': true,
                'red': showError(passwordConfirm1, 'minlength'),
                'green': showSuccess(passwordConfirm1, 'minlength')
            }">
                <span class="icon-wrapper">
                    <aur-icon *ngIf="showError(passwordConfirm1, 'minlength')" color="danger">highlight_off</aur-icon>
                    <aur-icon *ngIf="showSuccess(passwordConfirm1, 'minlength')" color="success">check_circle_outline</aur-icon>
                </span>
                <span>{{ 'ARC_SHARED_COMPONENTS_PRESENTATION_PASSWORD_REQ_MINIMUM_LENGTH8' | translate}} </span>
            </div>
            <div [ngClass]="{
                'security-measure': true,
                'red': showError(passwordConfirm1, 'oneLowerCase'),
                'green': showSuccess(passwordConfirm1, 'oneLowerCase')
            }">
                <span class="icon-wrapper">
                    <aur-icon *ngIf="showError(passwordConfirm1, 'oneLowerCase')" color="danger">highlight_off</aur-icon>
                    <aur-icon *ngIf="showSuccess(passwordConfirm1, 'oneLowerCase')" color="success">check_circle_outline</aur-icon>
                </span>
                <span>{{ 'ARC_SHARED_COMPONENTS_PRESENTATION_PASSWORD_REQ_ONELOWERCASE' | translate }}</span>
            </div>
            <div [ngClass]="{
                'security-measure': true,
                'red':showError(passwordConfirm1, 'oneUpperCase'),
                'green':showSuccess(passwordConfirm1, 'oneUpperCase')
            }">
                <span class="icon-wrapper">
                    <aur-icon *ngIf="showError(passwordConfirm1, 'oneUpperCase')" color="danger">highlight_off</aur-icon>
                    <aur-icon *ngIf="showSuccess(passwordConfirm1, 'oneUpperCase')" color="success">check_circle_outline</aur-icon>
                </span>
                <span>{{ 'ARC_SHARED_COMPONENTS_PRESENTATION_PASSWORD_REQ_ONEUPPERCASE' | translate }}</span>
            </div>
    
            <div [ngClass]="{
                'security-measure': true,
                'red':showError(passwordConfirm1, 'oneNumber'),
                'green':showSuccess(passwordConfirm1, 'oneNumber')
            }">
                <span class="icon-wrapper">
                    <aur-icon *ngIf="showError(passwordConfirm1, 'oneNumber')" color="danger">highlight_off</aur-icon>
                    <aur-icon *ngIf="showSuccess(passwordConfirm1, 'oneNumber')" color="success">check_circle_outline</aur-icon>
                </span>
                <span>{{ 'ARC_SHARED_COMPONENTS_PRESENTATION_PASSWORD_REQ_ONENUMBER' | translate }}</span>
            </div>
            <div [ngClass]="{
                'security-measure': true,
                'red':showError(passwordConfirm1, 'oneSpecialCharacter'),
                'green':showSuccess(passwordConfirm1, 'oneSpecialCharacter')
            }">
                <span class="icon-wrapper">
                    <aur-icon *ngIf="showError(passwordConfirm1, 'oneSpecialCharacter')" color="danger">highlight_off</aur-icon>
                    <aur-icon *ngIf="showSuccess(passwordConfirm1, 'oneSpecialCharacter')" color="success">check_circle_outline</aur-icon>
                </span>
                <span>{{ 'ARC_SHARED_COMPONENTS_PRESENTATION_PASSWORD_REQ_ONSPECIALCHAR' | translate }}</span>
            </div>
        </div>
    </div>
    <div class="p-col-12">
        <aur-input
            type="password"
            autocomplete="new-password"
            formControlName="passwordConfirm1"
            [showClearButton]="true"
            [label]="'ARC_SHARED_COMPONENTS_PRESENTATION_PASSWORD_1_LABEL' | translate"
            [errorMessages]="{
                'minlength': 'ARC_SHARED_COMPONENTS_PRESENTATION_PASSWORD_REQ_ERROR_VALIDATION' | translate,
                'oneLowerCase': 'ARC_SHARED_COMPONENTS_PRESENTATION_PASSWORD_REQ_ERROR_VALIDATION' | translate,
                'oneNumber': 'ARC_SHARED_COMPONENTS_PRESENTATION_PASSWORD_REQ_ERROR_VALIDATION' | translate,
                'oneSpecialCharacter': 'ARC_SHARED_COMPONENTS_PRESENTATION_PASSWORD_REQ_ERROR_VALIDATION' | translate,
                'oneUpperCase': 'ARC_SHARED_COMPONENTS_PRESENTATION_PASSWORD_REQ_ERROR_VALIDATION' | translate,
                'required': 'ARC_SHARED_COMPONENTS_PRESENTATION_PASSWORD_REQ_ERROR_VALIDATION' | translate
            }"
        ></aur-input>
    </div>
    <div class="p-col-12">
        <aur-input
            type="password"
            formControlName="passwordConfirm2"
            autocomplete="new-password"
            [showClearButton]="true"
            [label]="'ARC_SHARED_COMPONENTS_PRESENTATION_PASSWORD_CONFIRM_LABEL' | translate"
            [errorMessages]="{
                'fieldMatch': 'ARC_SHARED_COMPONENTS_PRESENTATION_PASSWORD_REQ_ERROR_MATCH' | translate,
                'required': 'ARC_SHARED_COMPONENTS_PRESENTATION_PASSWORD_REQ_ERROR_MATCH' | translate
            }"
        ></aur-input>
    </div>

    
    <div class="p-col-12">
        <!-- <aur-validation-error
            [form]="passwordFormGroup"
            for="form"
            [errorMessages]="{
                'fieldMatch': 'ARC_SHARED_COMPONENTS_PRESENTATION_PASSWORD_REQ_ERROR_MATCH' | translate
            }"
        ></aur-validation-error> -->
        <!-- <aur-notice severity="error" *ngIf="passwordFormGroup?.errors?.fieldMatch">
            {{ 'ARC_SHARED_COMPONENTS_PRESENTATION_PASSWORD_REQ_ERROR_MATCH' | translate }}
        </aur-notice> -->
        <button type="submit" id="btSetNewPassword" class="reset-button" aur-button>{{ 'ARC_SHARED_COMPONENTS_PRESENTATION_SAVE_PASSWORD_BUTTON'
            | translate}}</button>
    </div>
    <div *ngIf="backButtonVisible" class="p-col-12 ui-md-12">
        <button type="button" aur-button (click)="goBack($event)" icon="arrow_back" importance="tertiary">{{ 'ARC_SHARED_COMPONENTS_BACK'
            | translate }}</button>
    </div>
</form>
